import React, { Component } from 'react';

class HotelsSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="hotel-network-wrapper">
        <h3 className="mb-4 skeleton-shine"/>
        <div className="hotel-wrapper mb-3">
          {Array.from(Array(16).keys()).map((i) => {
            return (
              <div className="single-hotel" key={i}>
                <div className="single-hotel-wrapper skeleton mb-3">
                  <div className="preview-images skeleton-shine"/>
                  <div className="hotel-info">
                    <div className="name skeleton-shine"/>
                    <div className="distance skeleton-shine"/>
                    <div className="price skeleton-shine"/>
                    <div className="discount skeleton-shine mt-auto"/>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default HotelsSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/HotelsSkeleton/HotelsSkeleton.js